"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Modal = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Text2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Loading = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Loading"));
var _Tabs = _interopRequireWildcard(require("@kiwicom/orbit-components/lib/Tabs"));
var _Illustration2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _useMediaQuery = _interopRequireDefault(require("@kiwicom/orbit-components/lib/hooks/useMediaQuery"));
var _MarketSelect2 = _interopRequireDefault(require("./components/MarketSelect"));
var _CurrencySelect = _interopRequireDefault(require("./components/CurrencySelect"));
var _context = require("../../../services/log/context");
var _events = require("../../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
var _Illustration, _Text, _FormattedMessage, _TabList;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MARKETS_DATA = "https://static-data.kiwi.com/marketsLanguages.json";
const MarketCurrencySelector = _ref => {
  var _MarketSelect;
  let {
    onClose,
    market: currentMarketId,
    language: currentLanguageId,
    currency: currentCurrencyId,
    closable = true,
    onLanguageChange = () => {},
    onCurrencyChange = () => {},
    onMarketChange = () => {},
    triggerRef
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  const {
    log
  } = (0, _context.useLog)();
  const {
    isTablet
  } = (0, _useMediaQuery.default)();
  const [markets, setMarkets] = React.useState();
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const fetchMarkets = async () => {
      const response = await fetch(MARKETS_DATA);
      const data = await response.json();
      setMarkets(data);
    };
    if (loading) {
      fetchMarkets().catch(err => {
        log(_events.REGIONAL_SETTINGS_ERROR, {
          error: String(err)
        });
        setMarkets(null);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [log, onClose, loading]);
  const handleMarketChange = _ref2 => {
    let {
      marketId,
      languageId
    } = _ref2;
    log(_events.REGIONAL_SETTINGS_MARKET_AND_LANGUAGE_CHANGE, {
      actionOrigin: "navbar",
      originalMarket: currentMarketId,
      newMarket: marketId,
      originalLanguage: currentLanguageId,
      newLanguage: languageId
    });
    if (marketId !== currentMarketId) {
      onMarketChange(marketId);
    }
    if (languageId !== currentLanguageId) {
      onLanguageChange(languageId);
    }
    onClose();
  };
  const MarketsContent = () => markets ? _MarketSelect || (_MarketSelect = /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarketSelect2.default, {
    markets: markets,
    setMarket: handleMarketChange,
    marketId: currentMarketId,
    languageId: currentLanguageId
  })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    direction: "column",
    spacing: "400",
    children: [_Illustration || (_Illustration = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration2.default, {
      name: "Error404",
      size: "small"
    })), _Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text2.default, {
      size: "small",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.market_settings_modal.regions_load_failed"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      fullWidth: !isTablet,
      onClick: () => setLoading(true),
      children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.market_settings_modal.reload"
      }))
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
    size: "extraLarge",
    onClose: onClose,
    hasCloseButton: closable,
    isMobileFullPage: true,
    dataTest: "RegionalSettingsModal",
    labelClose: intl.formatMessage({
      id: "orbit.button_close"
    }),
    ariaLabel: intl.formatMessage({
      id: "account.market_settings_modal.region_language"
    }),
    triggerRef: triggerRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      padding: {
        top: "600",
        bottom: "600",
        right: "400",
        left: "400"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tabs.default, {
        children: [_TabList || (_TabList = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tabs.TabList, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.Tab, {
            dataTest: "region-language-selector",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.market_settings_modal.region_language"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.Tab, {
            dataTest: "currency-selector",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.market_settings_modal.currency"
            })
          })]
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tabs.TabPanels, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.TabPanel, {
            children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.default, {
              loading: true,
              type: "pageLoader",
              title: intl.formatMessage({
                id: "common.loading"
              })
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(MarketsContent, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.TabPanel, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrencySelect.default, {
              setCurrency: onCurrencyChange,
              currencyId: currentCurrencyId
            })
          })]
        })]
      })
    })
  });
};
var _default = exports.default = MarketCurrencySelector;